import { render, staticRenderFns } from "./UpdateNotification.vue?vue&type=template&id=2850a465&scoped=true"
import script from "./UpdateNotification.vue?vue&type=script&lang=js"
export * from "./UpdateNotification.vue?vue&type=script&lang=js"
import style0 from "./UpdateNotification.vue?vue&type=style&index=0&id=2850a465&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2850a465",
  null
  
)

export default component.exports